import axios from "axios";
import {API_URL} from "@env";

export const getContents = () => {
    return axios.get(API_URL + `/get-contents/0`);
}
